module.exports = __webpack_public_path__ + "img/arrow-customize-builder-back.2e3bc46d.svg";